<template>
  <div class="activity-container">
    <div class="activity-inner">
      <!-- <div>
        <h1 class="activity-title">近期活动</h1>
        <div class="activity-item" v-for="item in activityList" :key="item.id">
          <img class="img" :src="item.url">
          <h1 class="title">{{item.title}}</h1>
        </div>
      </div> -->
      <div class="prev-activity">
        <!-- <h1 class="activity-title">往期活动</h1> -->
        <div class="activity-item" v-for="item in prevList" :key="item.vid" @click="toVideo(item)">
          <img class="img" :src="getBgImg(item.bgimg)">
          <h1 class="title">{{item.title}}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jrConfig from '@/config/jinrong.js'
import bg1 from '@/assets/jinrong-bg-1.png'
import bg2 from '@/assets/jinrong-bg-2.png'
import bg3 from '@/assets/jinrong-bg-3.png'
import bg4 from '@/assets/jinrong-bg-4.png'

export default {
  name: 'ActivityList',
  data() {
    return {
      activityList: [
        {
          id: 1,
          title: '2022中国国际金融展开幕式',
          url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_1.png'
        },
        {
          id: 2,
          title: '2022中国国际金融展开幕式',
          url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_2.png'
        },
        {
          id: 3,
          title: '2022中国国际金融展开幕式',
          url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
        }
      ],
      prevList: jrConfig.opening
    }
  },
  methods: {
    toVideo(item) {
      this.$router.push({
        name: 'play',
        query: {
          vid: item.vid,
          video: item.url
        }
      })
    },
    getBgImg(bgimg) {
      switch(bgimg) {
        case '1':
          return bg1
        case '2':
          return bg2
        case '3':
          return bg3
        case '4':
          return bg4
      }
    }
  }
}
</script>

<style scoped>
.activity-container {
  width: 100%;
  max-width: 750px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
}
.activity-inner {
  width: 100%;
  padding: 0 14px;
  box-sizing: border-box;
  background: #ffffff;
  padding-top: 14px;
}
.activity-title {
  margin: 0;
  padding: 12px 0;
  font-size: 14px;
}
.activity-title.prev {
  padding-top: 0;
}
.activity-item {
  width: 100%;
  margin-bottom: 14px;
  position: relative;
  font-size: 0;
}
.activity-item .img {
  width: 100%;
}
.activity-item .title {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  margin: 0;
  font-size: 18px;
  color: #ffffff;
  font-weight: normal;
  text-align: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.prev-activity {
  padding-bottom: 30px;
}
</style>